import styled from 'styled-components';

export const StyledUnderline = styled.div<{ isSelected: boolean }>`
  border-bottom: ${props =>
    props.isSelected && `2px solid ${props.theme.colors.seedlyBlue}`};
  padding-bottom: ${props => props.theme.spacing.sm};
`;

export const FullWidthWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  cursor: pointer;
`;

export const FullWidthTextWrapper = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  border-bottom: ${props =>
    props.isSelected
      ? `2px solid ${props.theme.colors.seedlyBlue}`
      : `1px solid ${props.theme.colors.neutral4}`};
  padding-bottom: ${props => props.theme.spacing.sm};
`;
